export default "__VITE_ASSET__DQnuOB1f__"